module.exports = __webpack_public_path__ + "static/img/CLP2.dcbe1c9.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/schoolEnrollment/CLP2.jpg
// module id = A6FI
// module chunks = 1